import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createStikers, seeStikers } from '../../../actions/userActions'
import ListStickersView from '../../containers/Stickers/ListStickers'

const ListStickers = () => {
  const dispatch = useDispatch()
  const { ecoStikers } = useSelector(state => state.userInfo)
  const [isEdit, setIsEdit] = useState(false)
  useEffect(() => {
    dispatch(seeStikers())

    return () => {

    }
  }, [])
  const formik = useFormik({
    initialValues: {
      name: ""
    },
    onSubmit: ({name, image}) => {
      const formData = new FormData()
      formData.append("name", name)
      formData.append("image", image)
      if (!isEdit) {
        dispatch(createStikers(formData))
      //  dispatch(createRank(formData))
      } else {

     //   formData.append("levelID", idSticker)
        //dispatch(editRank(formData))
      }
    }
  })
  
  return (
    <ListStickersView formik={formik} stickers={ecoStikers}  isEdit={isEdit} setIsEdit={setIsEdit} />
  )
}

export default ListStickers